import React, { useState } from 'react';
import moment from 'moment';
import { has } from 'lodash';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { StyledField } from 'styles/form';
import loginImage from 'assets/images/login.jpg';
import logo from '../../../assets/images/logo-ghs-full-width.svg';
import Form from 'components/ui/Form';
import { login } from 'api/auth';
import { useSnackBar } from 'context/SnackBarContext';
import {
  Page,
  LeftContent,
  Content,
  LoginButton,
  FormTitle,
  Logo,
  Image,
  Disclaimer,
} from './styles';

const Login = ({ history }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { setMessage, setOpenSnackBar, setSeverity } = useSnackBar();

  const handleLogin = async (values) => {
    const { email, password } = values;

    try {
      await login(email, password);
      localStorage.setItem(
        'token_expiration',
        moment().add(15, 'minutes').toDate(),
      );
      history.go(0);
    } catch (error) {
      console.error(error);
      setMessage('Log in failed. Please try again.');
      setSeverity('error');
      setOpenSnackBar(true);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Page>
      <LeftContent>
        <Content>
          <Logo src={logo} alt="GHS Logo" />

          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email().required('email is required'),
              password: Yup.string().required('password is required'),
            })}
            enableReinitialize
            onSubmit={handleLogin}
          >
            {({
              values: { email, password },
              errors,
              handleChange,
              submitForm,
              touched,
            }) => (
              <Form fullWidth>
                <FormTitle>Log in</FormTitle>

                <TextField
                  color="primary"
                  error={touched.email && has(errors, 'email')}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email"
                  name="email"
                  onChange={handleChange}
                  value={email}
                  type="email"
                  variant="outlined"
                />

                <FormControl variant="outlined">
                  <StyledField variant="outlined">
                    <InputLabel
                      htmlFor="outlined-adornment-password"
                      error={touched.password && has(errors, 'password')}
                      helperText={touched.password && errors.password}
                      required
                    >
                      Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      name="password"
                      error={touched.password && has(errors, 'password')}
                      helperText={touched.password && errors.password}
                      required
                      onChange={handleChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={75}
                    />

                    {errors.password && touched.password && (
                      <FormHelperText error={has(errors, 'password')}>
                        {errors.password}
                      </FormHelperText>
                    )}
                  </StyledField>
                </FormControl>

                <LoginButton fullWidth onClick={submitForm}>
                  Login
                </LoginButton>
              </Form>
            )}
          </Formik>

          <Disclaimer>
            ©2021 Global Health Solutions. All rights reserved.
          </Disclaimer>
        </Content>
      </LeftContent>

      <Image src={loginImage} alt="Login Image" />
    </Page>
  );
};

export default Login;
